import { c as _c } from "react/compiler-runtime";
import useChatMessageStore from '@module/stores/useChatMessageStore';
import useChatPanelStore from '@module/stores/useChatPanelStore';
import { useFetchLivePlayMutationStore } from '@module/stores/useFetchLivePlayMutationStore';
import { checkIsMobile } from '@module/utils/checkIsMobile';
import TimeConstants from '@module/utils/item';
import { useEffect } from 'react';
import useGetLoginInfoQuery from '../auth/useGetLoginInfoQuery';
import constructFreezeOnPayload from './constructFreezeOnPayload';

/**
 * @description 채팅 초기 진입 시 처리해야 하는 비즈니스 로직 정의
 */
function useChatInitiator() {
  const $ = _c(11);
  const {
    data: playInfo
  } = useFetchLivePlayMutationStore();
  const chatMessages = useChatMessageStore(_temp);
  const setChatMessages = useChatMessageStore(_temp2);
  const {
    setIsChattingSettingOpen,
    setIsFanListPopupOpen,
    setIsChatEmoticonSelectBoxOpen
  } = useChatPanelStore(_temp3);
  const {
    isLogin,
    siteMode
  } = useGetLoginInfoQuery();
  let t0;
  if ($[0] !== chatMessages || $[1] !== isLogin || $[2] !== playInfo || $[3] !== setChatMessages || $[4] !== setIsChatEmoticonSelectBoxOpen || $[5] !== setIsChattingSettingOpen || $[6] !== setIsFanListPopupOpen || $[7] !== siteMode?.mode) {
    t0 = () => {
      if (!playInfo) {
        return;
      }
      const isChatHideMode = playInfo.chatMode === "hide";
      if (isChatHideMode) {
        setChatMessages([]);
        return;
      }
      const isSilverModeAdultBroadcast = playInfo.playMode === "adult" && siteMode?.mode === "s";
      if (isSilverModeAdultBroadcast) {
        const isMobile = checkIsMobile();
        const guidedTitle = isLogin ? "\uBCF8\uC778\uC778\uC99D" : "\uD68C\uC6D0\uAC00\uC785";
        const handleGuidedMessage = message => {
          setChatMessages(prev => [...prev, {
            data: {
              type: "ChatIntro",
              message
            },
            offset: Date.now()
          }]);
        };
        const handleGuidedMessageTimer = setInterval(() => {
          handleGuidedMessage(isMobile ? `HOT한 채팅이 진행 중입니다. \n\"${guidedTitle}\" 후 채팅 내용을 확인할 수 있습니다.` : `*****************************************\nHOT한 채팅이 진행 중입니다. \n\"${guidedTitle}\" 후 채팅 내용을 확인할 수 있습니다.\n*****************************************`);
        }, TimeConstants.ONE_SECOND * 3);
        return () => {
          clearInterval(handleGuidedMessageTimer);
        };
      }
      const isChatFrozen = playInfo.roomFreezeInfo?.enable;
      const isFirstEnter = chatMessages.length === 0;
      if (isFirstEnter && isChatFrozen) {
        setChatMessages(prev_0 => [...prev_0, constructFreezeOnPayload({
          name: playInfo.roomFreezeInfo?.name || "",
          messageType: "past"
        })]);
      }
      return () => {
        setIsChattingSettingOpen(false);
        setIsFanListPopupOpen(false);
        setIsChatEmoticonSelectBoxOpen(false);
      };
    };
    $[0] = chatMessages;
    $[1] = isLogin;
    $[2] = playInfo;
    $[3] = setChatMessages;
    $[4] = setIsChatEmoticonSelectBoxOpen;
    $[5] = setIsChattingSettingOpen;
    $[6] = setIsFanListPopupOpen;
    $[7] = siteMode?.mode;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  let t1;
  if ($[9] !== playInfo) {
    t1 = [playInfo];
    $[9] = playInfo;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  useEffect(t0, t1);
}
function _temp3(state_1) {
  return {
    setIsChattingSettingOpen: state_1.setIsChattingSettingOpen,
    setIsFanListPopupOpen: state_1.setIsFanListPopupOpen,
    setIsChatEmoticonSelectBoxOpen: state_1.setIsChatEmoticonSelectBoxOpen
  };
}
function _temp2(state_0) {
  return state_0.setChatMessages;
}
function _temp(state) {
  return state.chatMessages;
}
export default useChatInitiator;